import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 31,
    seconds: 23
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let s = prev.seconds - 1,
          m = prev.minutes,
          h = prev.hours;
        if (s < 0) {
          s = 59;
          m -= 1;
        }
        if (m < 0) {
          m = 59;
          h -= 1;
        }
        return {
          hours: h,
          minutes: m,
          seconds: s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <section className="py-6 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-red-950/60 to-black" data-id="element-34">
      <div className="max-w-3xl mx-auto text-center" data-id="element-35">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-white mb-4 flex items-center justify-center gap-2" data-id="element-36">
          <span data-id="element-37">⏰</span> EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="flex justify-center items-baseline gap-2 md:gap-4 mb-2" data-id="element-38">
          <div className="flex flex-col items-center" data-id="element-39">
            <span className="text-4xl md:text-6xl font-black text-red-500" data-id="element-40">
              {fmt(timeLeft.hours)}
            </span>
            <span className="text-gray-400 mt-1 font-bold uppercase tracking-wider text-xs" data-id="element-41">
              HS
            </span>
          </div>
          <span className="text-4xl md:text-6xl font-black text-red-500 -mt-2" data-id="element-42">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-43">
            <span className="text-4xl md:text-6xl font-black text-red-500" data-id="element-44">
              {fmt(timeLeft.minutes)}
            </span>
            <span className="text-gray-400 mt-1 font-bold uppercase tracking-wider text-xs" data-id="element-45">
              MIN
            </span>
          </div>
          <span className="text-4xl md:text-6xl font-black text-red-500 -mt-2" data-id="element-46">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-47">
            <span className="text-4xl md:text-6xl font-black text-red-500" data-id="element-48">
              {fmt(timeLeft.seconds)}
            </span>
            <span className="text-gray-400 mt-1 font-bold uppercase tracking-wider text-xs" data-id="element-49">
              SEG
            </span>
          </div>
        </div>

        <p className="text-lg md:text-xl text-white font-bold mb-4" data-id="element-50">
          Después sube <span className="text-red-500" data-id="element-51">$10.000 ARS</span> y no
          vuelve a bajar.
        </p>

        <div className="max-w-xl mx-auto mb-4" data-id="element-52">
          <div className="flex justify-between text-xs md:text-sm font-bold mb-1" data-id="element-53">
            <span className="flex items-center gap-2 text-gray-300" data-id="element-54">
              <span className="w-2.5 h-2.5 bg-orange-500 rounded-full" data-id="element-55"></span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-white font-bold" data-id="element-56">Quedan pocos</span>
          </div>
          <div className="w-full bg-gray-700 rounded-full h-3 overflow-hidden" data-id="element-57">
            <motion.div initial={{
            width: 0
          }} animate={{
            width: '68%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="bg-gradient-to-r from-orange-500 to-yellow-400 h-full rounded-full" data-id="element-58" />
          </div>
          <p className="text-right text-xs text-gray-400 mt-1" data-id="element-59">
            68% de los cupos tomados
          </p>
        </div>

        <motion.a href="#pricing" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-flex items-center justify-center w-full max-w-xl px-8 py-3 text-lg md:text-xl font-black uppercase tracking-wider rounded-lg transition-all duration-300 bg-green-500 text-black hover:bg-green-400 shadow-lg shadow-green-500/20 whitespace-nowrap" data-id="element-60">
          → ASEGURAR MI PRECIO AHORA
        </motion.a>
      </div>
    </section>;
}